<div
  class="ai-chat-container"
  [ngClass]="{
    active: isOpen,
    'bottom-right': position === 'bottom-right',
    'bottom-left': position === 'bottom-left',
    'top-right': position === 'top-right',
    'top-left': position === 'top-left',
    maximized: isMaximized,
  }"
  [style.transition-duration.ms]="config.animationDuration"
>
  <div class="ai-chat-header">
    <div class="ai-chat-controls">
      <button
        class="control-button"
        (click)="toggleMaximize()"
        title="{{ isMaximized ? 'Minimize' : 'Maximize' }}"
      >
        <i class="{{ isMaximized ? 'minimize-icon' : 'maximize-icon' }}"></i>
      </button>
      <button class="control-button" (click)="close()" title="Close">
        <i class="close-icon"></i>
      </button>
    </div>
  </div>
  <div class="ai-chat-content">
    <ng-container
      *ngIf="config.iframeUrl && safeIframeUrl; else placeholderContent"
    >
      <iframe
        [src]="safeIframeUrl"
        frameborder="0"
        class="chat-iframe"
      ></iframe>
    </ng-container>
    <ng-template #placeholderContent>
      <div class="placeholder-text">here will be a chat</div>
    </ng-template>
  </div>
</div>
